import { useEffect } from "react";
import { OutletContextProps, withRouter } from "../../helpers/RouterHelper";
import { AuthenticatedPageProps } from "../../hocs/enhanceAuthenticatedPage";
import enhanceSectionsPage from "../../hocs/enhanceSectionsPage";
import { useQueryError } from "../../hooks/http/useQueryError";
import { useOnMainScrollAreaScroll } from "../../hooks/useMainScrollAreaScroll";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionStaffBoardPosts from "./SectionStaffBoardPosts";
import { useFetchStaffBoardPosts } from "./useFetchStaffBoardPosts";

interface Props
  extends OutletContextProps,
    Pick<AuthenticatedPageProps, "currentOperator"> {
  section: SectionInterface;
}

const SectionsStaffBoardPostsPage: React.FC<Props> = (props) => {
  const { section, currentOperator, setActiveMenu } = props;

  useEffect(() => {
    setActiveMenu("dashboard");
  }, []);

  const { staffBoardPosts, isLoading, error, fetchNextStaffBoardPosts } =
    useFetchStaffBoardPosts({
      sectionId: section.id,
    });
  useQueryError(error);

  useOnMainScrollAreaScroll(
    () => fetchNextStaffBoardPosts(),
    [fetchNextStaffBoardPosts],
  );

  return (
    <SectionStaffBoardPosts
      section={section}
      currentOperator={currentOperator}
      staffBoardPosts={staffBoardPosts}
      isLoading={isLoading}
    />
  );
};

const pageInfo = {
  title: "スタッフボード",
};

const EnhancedPage = enhanceSectionsPage(SectionsStaffBoardPostsPage, pageInfo);

export default withRouter(EnhancedPage);
